import * as React from 'react'
import { useTranslations } from 'next-intl'

import { postV1UsersSessionsClient } from '@/generated/clients/axios/AuthenticationService'
import { parseResponseErrors } from 'utils/api-errors'
import { mapUserToUserType } from 'utils/api-type-mappers'
import AuthContext from 'lib/authContext'

import AuthHeader from 'components/AuthHeader'
import LoginForm from 'components/LoginForm'

import { useRouter } from 'next/router'

function LoginPage() {
  const t = useTranslations()
  const authContext = React.useContext(AuthContext)
  const router = useRouter()

  React.useEffect(() => {
    if (authContext.isRehydrated && authContext.userData) {
      router.replace('/parcels') // or your desired route
    }
  }, [authContext.isRehydrated, authContext.userData, router])

  async function handleSubmit(values: any, actions: any) {
    actions.setSubmitting(true)

    try {
      const { data } = await postV1UsersSessionsClient({
        user: {
          email: values.email,
          password: values.password,
        },
      })
      const userData = mapUserToUserType(data)
      authContext.login(data.jwt_token!, userData, values.rememberMe)
    } catch (error: any) {
      actions.setSubmitting(false)
      console.log('Error submitting login request', error)

      const submitErrors = parseResponseErrors(error, t)
      if (submitErrors && Object.keys(submitErrors).length > 0) {
        actions.setErrors(submitErrors)
      }
    }
  }

  if (authContext.isRehydrated && authContext.userData) {
    return null // or a loading spinner
  }

  return (
    <div className="container">
      <AuthHeader login />

      <LoginForm onSubmit={handleSubmit} />
    </div>
  )
}

LoginPage.title = 'loginPage.title'

export default LoginPage
